module.exports = __webpack_public_path__ + "public/img/demo.74b4f998.jpg";